import React from "react";
import logo from "../../img/innlink_logo.svg"
import SubMenu from "./SubMenu";
import {Link} from 'react-router-dom';
import {I18n} from 'react-redux-i18n';
import _ from "../../utils/ObjectUtils";
import UserHasPermission, {appModules, modulesActions} from "../../../roles/components/UserHasPermission";

class Menu extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            openMenu: this.generateOpenMenu(props.path),
            path: this.generatePathName(props.path)
        }
    };

    handleHeaderClicked = (menuName) => {
        const { openMenu } = this.state;
        menuName = openMenu === menuName ? "" : menuName;
        this.setState({ openMenu: menuName });
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.path !== this.props.path) {
            this.updateSelectedPath(this.generatePathName(this.props.path));
        }
    };

    generatePathName = path => {
        let namePath = path.substring(1, path.length);
        if (path.lastIndexOf('/') === namePath.length) {
            namePath = namePath.substring(0, namePath.length - 1)
        }
        let tabPosition = namePath.lastIndexOf('/');
        if (tabPosition !== -1) {
            namePath = namePath.substring(0, tabPosition);
        }
        let optionalTabPosition = namePath.indexOf('/');
        if (optionalTabPosition !== -1) {
            namePath = namePath.substring(0, optionalTabPosition);
        }
        return namePath;
    };

    generateOpenMenu = path => {
        let openMenu = "";
        const namePath = this.generatePathName(path);
        _.forOwn(
            submenus,
            menu => {
                if (menu.menuOptions.findIndex(route => route.id === namePath) !== -1) {
                    openMenu = menu.id;
                }
            }
        );
        return openMenu;
    };

    updateSelectedPath = newPath => {
        this.setState({
            path: this.generatePathName(newPath)
        });
    };

    render() {
        const { openMenu, path } = this.state;

        return (
            <div className="bm-menu-wrap">
                <div className="bm-menu">
                    <nav className="bm-item-list">
                        <div className="logo-container">
                            <img className="img-fluid" alt="logo" src={logo} />
                        </div>
                        <div className="divider" />
                        <Link
                            className={"bm-item " + (path === "dashboard" ? "is-selected" : "")}
                            to="/dashboard"
                        >
                            {I18n.t('routes.dashboard')}
                        </Link>
                        <UserHasPermission
                            appModule={appModules.ENTITY}
                            action={modulesActions.READ}
                        >
                            <Link
                                className={"bm-item " + (path === "meetingRooms" ? "is-selected" : "")}
                                to="/meetingRooms"
                            >
                                {I18n.t('routes.meetingRooms')}
                            </Link>
                            <Link
                                className={"bm-item " + (path === "buildings" ? "is-selected" : "")}
                                to="/buildings">
                                {I18n.t('routes.buildings')}
                            </Link>
                        </UserHasPermission>
                        <UserHasPermission
                            appModule={appModules.PARKING}
                            action={modulesActions.READ}
                        >
                            <Link
                                className={"bm-item " + (path === "parking" ? "is-selected" : "")}
                                to="/parking">
                                {I18n.t('routes.parkingList')}
                            </Link>
                        </UserHasPermission>
       {/*                  <SubMenu
                            activePath={path}
                            isOpen={openMenu === submenus.visits.id}

                            menuOptions={submenus.visits.menuOptions}
                            headerLabel={submenus.visits.id}

                            onSubMenuHeaderClicked={() => this.handleHeaderClicked(submenus.visits.id)}
                        />
                        <UserHasPermission
                            appModule={appModules.CONSOLE_USER}
                            action={modulesActions.READ}
                        >
                            <Link
                                className={"bm-item " + (path === "consoleUsers" ? "is-selected" : "")}
                                to="/consoleUsers">
                                {I18n.t('routes.consoleUsers')}
                            </Link>
                        </UserHasPermission> */}
                        <SubMenu
                            activePath={path}
                            isOpen={openMenu === submenus.admin.id}

                            menuOptions={submenus.admin.menuOptions}
                            headerLabel={submenus.admin.id}

                            onSubMenuHeaderClicked={() => this.handleHeaderClicked(submenus.admin.id)}
                        />
                    </nav>
                </div>
            </div>
        );
    }
}

const submenus = {
    admin: {
        id: 'admin',
        menuOptions: [{
            id: "entities",
            neededPermission: appModules.ENTITY
        }, {
            id: "users",
            neededPermission: appModules.USER
        }, /* {
            id: "rules",
            neededPermission: appModules.RULE
        }, */ {
            id: "roles",
            neededPermission: appModules.ROLE
        },
        {
            id: "consoleUsers",
            neededPermission: appModules.CONSOLE_USER
        },
        {
            id: "billingReport",
            neededPermission: appModules.BILLING_REPORT
        }, /* {
            id: "terminals",
            neededPermission: appModules.TERMINAL
        } */]
    },
    visits: {
        id: 'visits',
        menuOptions: [{
            id: "visitors",
            neededPermission: appModules.VISITOR
        }, {
            id: "plannedVisits",
            neededPermission: appModules.VISIT
        }, {
            id: "currentVisits",
            neededPermission: appModules.VISIT
        }, {
            id: "visitsHistoric",
            neededPermission: appModules.VISIT
        }]
    }
};

export default Menu;